import React from 'react';
import { CopiaxHeader } from './styles';

export default () => {
  return <CopiaxHeader>Reset password</CopiaxHeader>;
};
